import {useParams, Navigate} from "react-router-dom";

const RedirectComponent = ({path}) => {
  let { id } = useParams()
  let navigateUrl = `${path}${id}`
  return <Navigate to={navigateUrl} />
}

export default RedirectComponent;